import { motion } from "framer-motion";

/**
 * A slow, editorial marquee. Two identical tracks butted together animate -50%.
 */
export default function Marquee() {
    const words = [
        "The story of her 41 days.",
        "Keep the promise.",
        "Be her voice.",
        "For Danielle.",
        "Always for Danielle.",
    ];
    // Repeat to fill enough width
    const track = [...words, ...words, ...words];

    return (
        <section
            data-testid="marquee-section"
            className="relative w-full bg-[color:var(--paper)] py-16 sm:py-24 border-y border-neutral-300 overflow-hidden"
        >
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4 }}
                className="marquee-track font-serif text-[15vw] sm:text-[10vw] leading-none tracking-tight text-neutral-950 whitespace-nowrap"
                aria-hidden="true"
            >
                {track.map((w, i) => (
                    <span key={i} className="mr-16 sm:mr-24 inline-flex items-center gap-16 sm:gap-24">
                        <span className={i % 2 === 0 ? "italic font-light" : "font-normal"}>{w}</span>
                        <span className="inline-block w-4 h-4 sm:w-6 sm:h-6 bg-neutral-900 shrink-0" aria-hidden="true" />
                    </span>
                ))}
            </motion.div>
        </section>
    );
}
